import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { startProgress, stopProgress, resetProgress } from "../store/progress";
import { useRootState } from ".";

// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useProgressStore = () => {
  const progressState = useRootState((state) => state.progressStore);

  const dispatch = useDispatch();

  const boundStartProgress = useCallback(
    () => dispatch(startProgress()),
    [dispatch]
  );
  const boundStopProgress = useCallback(
    () => dispatch(stopProgress()),
    [dispatch]
  );
  const boundResetProgress = useCallback(
    () => dispatch(resetProgress()),
    [dispatch]
  );

  return {
    progressState,
    startProgress: boundStartProgress,
    stopProgress: boundStopProgress,
    resetProgress: boundResetProgress,
  };
};

export default useProgressStore;
